import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { selectIsLoading, selectMyProfileData, selectUserType } from 'redux/selectors/auth';
import { StateType } from 'types';
import { getMyProfileData } from 'redux/actions/auth';

const mapStateToProps = (state: StateType) => ({
  isLoading: selectIsLoading(state),
  userType: selectUserType(state),
  user: selectMyProfileData(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({ getMyProfileData }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
